import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { getSpanStyles, getBreakPointStyles } from './utils';

const baseStyles = ({ theme, columns }) => css`
  flex: 0 0 auto;
  position: relative;

  ${getBreakPointStyles(theme)};
  ${getSpanStyles(theme, columns)};
`;

const Col = styled('div')(baseStyles);

const sizingProp = PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]);

Col.propTypes = {
  columns: sizingProp,
};

Col.defaultProps = {
  columns: '0',
};

export default Col;
